export function stringSplice(string: any, start: any, delCount: any, newSubStr: any) {
  return string.slice(0, start) + newSubStr + string.slice(start + Math.abs(delCount));
}
